import { render } from "./VehicleEmployeeHistory.vue?vue&type=template&id=536f2cc9"
import script from "./VehicleEmployeeHistory.vue?vue&type=script&lang=js"
export * from "./VehicleEmployeeHistory.vue?vue&type=script&lang=js"

import "./VehicleEmployeeHistory.vue?vue&type=style&index=0&id=536f2cc9&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__